export const all_routes = {
  //region icons
  fontawesome: "/icon-fontawesome",
  feathericon: "/icon-feather",
  ionicicons: "/icon-ionic",
  materialicons: "/icon-material",
  pe7icons: "/icon-pe7",
  simpleline: "/icon-simpleline",
  themifyicons: "/icon-themify",
  iconweather: "/icon-weather",
  typicons: "/icon-typicon",
  flagicons: "/icon-flag",
  remixIcon: "/remix-icon",
  BootstrapIcon: "/bootstrap-icon",
  TablerIcon: "/tabler-icon",

  //region auth
  signin: "/signin",
  forgotPassword: "/forgot-password",

  //region layput demo
  Horizontal: "/layout-horizontal",
  Detached: "/layout-detached",
  Hovered: "/layout-hovered",
  Boxed: "/layout-box",
  Modern: "/layout-modern",
  TwoColumn: "/layout-two-column",
  Dark: "/layout-dark",
  RTL: "/layout-rtl",

  //region RollCall
  rollcalldashboard: "/rollcall/dashboard",
  rollcallregistrations: "/rollcall/registrations",
  rollcallrejoinemployees: "/rollcall/rejoin-employees",
  rollcallemployeeslist: "/rollcall/employees",
  rollcalladditionaldetails: "/rollcall/additional-details",
  rollcallmanualattendance: "/rollcall/manual-attendance",
  rollcallholidaysList: "/rollcall/holidays",
  rollcalldepartmentsList: "/rollcall/departments",
  rollcallemployeesaccessList: "/rollcall/employee-access",
  rollcallassignshifts: "/rollcall/shifts",
  rollcallleaveslist: "/rollcall/leaves",
  rollcallreports: "rollcall/reports/:id",
  rollcallleaveaccurals: "/rollcall/leaveaccurals",
  rollcallleavesummary: "/rollcall/leavesummary",
  rollcallleavetypes: "/rollcall/leavetypes",
  rollcallnotification: "/rollcall/notification",
  rollcallpermissions: "/rollcall/permissions",
  rollcallsettings: "/rollcall/settings",
  rollcallteammembers: "/rollcall/teammembers",
  profile: "/profile",
  rollcallwageregistrations: "/rollcall/wageregistrations",
  rollcallgroupreports: "/rollcall/groupreports/:id",
  rollcallOrgDashboard: "/rollcall/orgdashboard",
  rollcallshifts: "/rollcall/shiftslist",
  rollcallEmpShifts: "/rollcall/EmpShifts",
  rollcallEmpShiftInfo: "/rollcall/empshiftinfo",
  rollcallSwipeLocation: "/rollcall/swipelocation",
  //Visitor Routes
  rollcallvisitorlist: "/visitor/visitorlist",
  rollcallvisitorreport: "/visitor/visitorreport",
  rollcallEvents: "/visitor/events",
  rollcallEventVisitors: "/visitor/eventvisitors",

  //KPI
  rollcallkpimetrics: "/kpi/kpimetrics",
  rollcallkpimetricsreport: "/kpi/kpimetricsreport",
  rollcallkpidashboard: "/kpi/kpidashboard",
  rollcallkpiresponses: "/kpi/kpiresponses",
  rollcallresponseSummary: "/kpi/responseSummary",
  rollcallmetricdetails: "/kpi/metricdetails",
  rollcallkpireports: "/kpi/kpireports",
  rollcallkpiPerformanceReport: "/kpi/PerformanceReport",
  rollcallKpiBranchScore: "/kpi/BranchScore",
};
